import * as React from 'react'

import Portal from 'react-minimalist-portal'
import positions from './position'

import './Tooltip.scss'

const hoverDelay = 200
const touchToMouseOverDelay = 1000
const defaultBg = '#333'

interface TooltipProps {
  direction?: string
  className?: string
  content: string | JSX.Element
  background?: string
  color?: string
  padding?: string
  // eventToggle?: string,
  useHover?: boolean
  useDefaultStyles?: boolean
  fixed?: boolean
  children: JSX.Element
}

interface TooltipState {
  showTip: boolean
  hasHover: boolean
  ignoreShow: boolean
}

class Tooltip extends React.Component<TooltipProps, TooltipState> {
  public static defaultProps: Partial<TooltipProps> = {
    direction: 'up',
    className: '',
    background: '',
    color: '',
    padding: '10px',
    useHover: true,
    useDefaultStyles: false,
  }

  public tip: any
  public target: any

  constructor(props: TooltipProps) {
    super(props)
    this.state = {
      showTip: false,
      hasHover: false,
      ignoreShow: false,
    }

    this.showTip = this.showTip.bind(this)
    this.hideTip = this.hideTip.bind(this)
    this.checkHover = this.checkHover.bind(this)
    this.cancelTip = this.cancelTip.bind(this)
    this.toggleTip = this.toggleTip.bind(this)
    this.startHover = this.startHover.bind(this)
  }

  public toggleTip() {
    this.setState({ showTip: !this.state.showTip })
  }

  public showTip() {
    this.setState({ showTip: true })
  }

  public hideTip() {
    this.setState({ hasHover: false })
    this.setState({ showTip: false })
  }

  public startHover() {
    if (!this.state.ignoreShow) {
      this.setState({ hasHover: true })

      setTimeout(this.checkHover, hoverDelay)
    }
  }

  public checkHover() {
    if (this.state.hasHover) {
      this.setState({ showTip: true })
    }
  }

  public cancelTip() {
    this.setState({ ignoreShow: true })

    setTimeout(() => {
      this.setState({ ignoreShow: false })
    }, touchToMouseOverDelay)
  }

  public render() {
    const {
      direction,
      children,
      content,
      useHover,
      background,
      useDefaultStyles,
      fixed,
    } = this.props

    const currentPositions = positions(
      direction,
      this.tip,
      this.target,
      this.state,
      {
        background: useDefaultStyles ? defaultBg : background,
      },
      fixed,
    )

    const tipStyles: React.CSSProperties = {
      ...currentPositions.tip,
      position: fixed ? 'fixed' : 'absolute',
    }

    const arrowStyles: React.CSSProperties = {
      ...currentPositions.arrow,
      position: 'absolute',
      width: '0px',
      height: '0px',
      zIndex: 1001,
    }

    const props: React.DetailedHTMLProps<
      React.HTMLAttributes<HTMLElement>,
      HTMLDivElement
    > = {
      style: { position: 'relative' },
      ref: target => {
        this.target = target
      },
    }

    return (
      <div className={`srprs-tooltip ${this.props.className}`} {...props}>
        {useHover
          ? React.cloneElement(children, {
              onMouseEnter: this.startHover,
              onMouseLeave: this.hideTip,
            })
          : React.cloneElement(children, { onClick: this.toggleTip })}

        <Portal>
          <div
            className="react-tooltip-lite"
            style={tipStyles}
            ref={tip => {
              this.tip = tip
            }}
          >
            {content}
          </div>
          <div
            className={`react-tooltip-lite-arrow
                            react-tooltip-lite-${currentPositions.realDirection}-arrow`}
            style={arrowStyles}
          />
        </Portal>
      </div>
    )
  }
}

export default Tooltip
